import { LOGIN_ACTIONS } from "./actions";

export interface ILoginState {
  isPending: boolean;
  isError: boolean;
  errorMessage: string;
  userId: string;
  userType: number;
}

const initialState: ILoginState = {
  isPending: false,
  isError: false,
  errorMessage: "",
  userId: "",
  userType: -1,
};

export const loginReducer = (state: ILoginState = initialState, action): ILoginState => {
  switch (action.type) {
    case LOGIN_ACTIONS.LOGIN_PENDING: {
      return {
        ...state,
        isPending: true,
      };
    }
    case LOGIN_ACTIONS.LOGIN_FAILED: {
      return {
        ...state,
        isPending: false,
        isError: true,
        errorMessage: action.payload,
      };
    }
    case LOGIN_ACTIONS.LOGIN_SUCCESS: {
      return {
        ...state,
        isPending: false,
        isError: false,
        ...action.payload,
      };
    }
    default:
      return state;
  }
};
